import { ReactElement } from 'react';
import { Price as PriceComponent, PRICE_STYLE_TYPE, Tax } from 'b2b-components/theme/components/Price';
import { Props } from './Price.types';

export const Price = ({
  className,
  dataAttributes,
  isSecondary,
  price,
  tax,
}: Props): ReactElement => (
  <PriceComponent
    className={className}
    dataAttributes={dataAttributes}
    currency='CHF'
    price={price}
    styleType={isSecondary ? PRICE_STYLE_TYPE.secondary : undefined}
  >
    <Tax>
      <span
        dangerouslySetInnerHTML={{
          __html: tax,
        }}
      />
    </Tax>
  </PriceComponent>
);
